import { z } from "zod";

import { isoDateTimeSchema } from "./common";

export const feedbackSourceSchema = z.enum(["inbox", "playground"]);
export type FeedbackSource = z.infer<typeof feedbackSourceSchema>;

export const feedbackReasonSchema = z.object({
  code: z.string().min(1).max(64),
  name: z.string().min(1),
});
export type FeedbackReason = z.infer<typeof feedbackReasonSchema>;

export const feedbackReasonsResponseSchema = z.object({
  reasons: z.array(feedbackReasonSchema),
});

export const feedbackDraftSchema = z.object({
  polarity: z.enum(["up", "down"]),
  reason: z.string().min(1).max(64).nullable(),
  details: z.string().max(1000).nullable(),
});
export type FeedbackDraft = z.infer<typeof feedbackDraftSchema>;

export const feedbackSubmitRequestSchema = feedbackDraftSchema
  .extend({ source: feedbackSourceSchema })
  .superRefine((value, context) => {
    if (
      value.polarity === "up" &&
      (value.reason !== null || value.details !== null)
    ) {
      context.addIssue({
        code: "custom",
        message: "positive feedback cannot include reason or details",
      });
    }
  });
export type FeedbackSubmitRequest = z.infer<typeof feedbackSubmitRequestSchema>;

export const feedbackMessageIdSchema = z.string().min(1).max(191);
export const feedbackMessageIdsSchema = z
  .array(feedbackMessageIdSchema)
  .min(1)
  .max(100);
export const feedbackMessagesQuerySchema = z.object({
  message_id: feedbackMessageIdsSchema,
});

export const feedbackSnapshotSchema = z.object({
  messageId: z.string().min(1),
  polarity: z.enum(["up", "down"]),
  reason: z.string().nullable(),
  reasonName: z.string().nullable(),
  details: z.string().max(1000).nullable(),
  memberName: z.string().nullable(),
  submittedAt: isoDateTimeSchema,
});
export type FeedbackSnapshot = z.infer<typeof feedbackSnapshotSchema>;

export const feedbackListResponseSchema = z.object({
  feedback: z.array(feedbackSnapshotSchema),
});

export const feedbackSubmitResponseSchema = z.object({
  created: z.boolean(),
  feedback: feedbackSnapshotSchema,
});
